import {
  accessTokenLists,
  accountantResponse,
  companyList,
  createAccessTokenResponse,
  entrepreneurResponse,
  expectedBankAccountList,
  finishedFileResponse,
  fileUploadResponse,
  integratorsResponse,
  iscResponse,
  responseFromAggreg8,
  transactionResponse,
  pendingFileResponse,
  responseFromAggreg8BanksList,
  entrepreneurResponseWithoutPreregistered,
  responseFromAggreg8AccountsListMultipleElement,
  bankConfigs,
} from './fakeResponse';
import { USER_TYPE } from '../Model/Enums';

let preRegistered = true;

/**ENTREPRENEUR */
export const mockEntrepreneurAuthentication = async (req, res, ctx) => {
  const { email } = await req.json();
  if (email) {
    if (email.includes('@')) {
      return res(ctx.status(200), ctx.json(entrepreneurResponse), ctx.delay(150));
    }
    return res(ctx.status(400), ctx.json("Unable to send notification email to 'akarmi@barmi.hu'."), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing required parameter(s): email, captcha_response'), ctx.delay(150));
};

export const mockEntrepreneurRead = async (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(entrepreneurResponse), ctx.delay(150));
};

export const mockEntrepreneurUpdate = async (req, res, ctx) => {
  const { name, mobile } = await req.json();
  if (name && mobile) {
    const updatedResponse = { ...entrepreneurResponse, ...{ name, mobile } };
    return res(ctx.status(200), ctx.json(updatedResponse), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing required parameter(s): name, mobile'), ctx.delay(150));
};

/**ACCOUNTANT */
export const mockAccountantAuthentication = async (req, res, ctx) => {
  const { email, captcha_response } = await req.json();
  if (email && captcha_response) {
    if (email.includes('@')) {
      return res(ctx.status(200), ctx.json(entrepreneurResponse.companies[0].accountants[0]), ctx.delay(150));
    }
    return res(ctx.status(400), ctx.json("Unable to send notification email to 'akarmi@barmi.hu'."), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing required parameter(s): email, captcha_response'), ctx.delay(150));
};

export const mockUpdateAccountant = async (req, res, ctx) => {
  const { name, mobile, email, company_id } = await req.json();
  const { id } = req.params;
  if (id !== 'undefined' && name && mobile && email && company_id !== 'undefined') {
    const updatedResponse = { ...accountantResponse, ...{ name, mobile, email } };
    return res(ctx.status(200), ctx.json(updatedResponse), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing required parameter(s): name, mobile'), ctx.delay(150));
};

export const mockCreateAccountant = async (req, res, ctx) => {
  const { name, mobile, email, company_id } = await req.json();
  if (name && mobile && email && company_id !== 'undefined') {
    const response = { ...accountantResponse, ...{ name, mobile, email } };
    return res(ctx.status(200), ctx.json(response), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing required parameter(s): name, mobile'), ctx.delay(150));
};

export const mockDeleteAccountant = (req, res, ctx) => {
  const { companyId, accountantId } = req.params;

  if (companyId !== 'undefined' && accountantId !== 'undefined') {
    return res(ctx.status(200), ctx.json(accountantResponse));
  }
  return res(ctx.status(400), ctx.json('Missing id.'));
};

export const mockListAccountants = (req, res, ctx) => {
  const { id } = req.params;
  if (id !== 'undefined') {
    const response = id === 'some_company_id' ? [accountantResponse] : [];
    return res(ctx.status(200), ctx.json(response));
  }
  return res(ctx.status(400), ctx.json('Missing id.'));
};

/**COMPANY */
export const mockListCompanies = async (req, res, ctx) => {
  if (!req.headers.get('authorization')) {
    return res(ctx.status(400), ctx.json('Access denied'));
  }
  return res(ctx.status(200), ctx.json(companyList), ctx.delay(150));
};

export const mockCreateCompany = async (req, res, ctx) => {
  const { tax_number, company_name } = await req.json();
  if (tax_number && company_name !== 'undefined') {
    return res(ctx.status(201), ctx.json(entrepreneurResponse.companies[0]), ctx.delay(150));
  }
  return res(ctx.json('Missing value(s): id, tax_number,company_name'), ctx.status(400), ctx.delay(150));
};
export const mockCompanyUpdate = async (req, res, ctx) => {
  const { tax_number, company_name } = await req.json();
  if (tax_number && company_name !== 'undefined') {
    preRegistered = false;
    return res(
      ctx.status(201),
      ctx.json({ ...entrepreneurResponse.companies[0], preRegistered: null }),
      ctx.delay(150)
    );
  }
  return res(ctx.json('Missing value(s): id, tax_number,company_name'), ctx.status(400), ctx.delay(150));
};

export const mockReadCompany = async (req, res, ctx) => {
  const { id } = req.params;
  if (id !== 'undefined') {
    return res(ctx.status(200));
  }
  return res(ctx.status(400), ctx.json('Missing company id.'));
};

export const mockDeleteCompanyIsc = async (req, res, ctx) => {
  const { company_id, account_id } = await req.json();
  if (company_id && account_id) {
    return res(ctx.status(200), ctx.json(expectedBankAccountList[0]));
  }
  return res(ctx.status(400), ctx.json('Missing company_id, account_id.'), ctx.delay(150));
};

export const mockPatchCompanyAggreg8accounts = async (req, res, ctx) => {
  const { account_number } = await req.json();
  if (account_number) {
    return res(ctx.status(201), ctx.json(entrepreneurResponse.companies[0]), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing value(s): id'), ctx.delay(150));
};

export const mockPatchBankConfig = async (req, res, ctx) => {
  const { company_id } = await req.json();
  if (company_id) {
    return res(ctx.status(201), ctx.json(entrepreneurResponse.companies[0]), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing company_id'), ctx.delay(150));
};

/**BANKACCOUNT */

export const mockListBankAccount = async (req, res, ctx) => {
  const companyId = req.url.searchParams.get('company_id');
  if (companyId) {
    if (companyId === 'empty') {
      return res(ctx.status(200), ctx.json([]));
    }
    return res(ctx.status(200), ctx.json(expectedBankAccountList));
  }
  return res(ctx.status(403), ctx.json('Missing company id.'), ctx.delay(150));
};

export const mockBankAccountDisplayNameUpdate = async (req, res, ctx) => {
  const { accountNr } = req.params;
  if (accountNr !== 'undefined') {
    return res(ctx.status(200));
  }
  return res(ctx.status(403), ctx.json('Missing bank account id.'), ctx.delay(150));
};

export const mockDeleteBankAccount = async (req, res, ctx) => {
  const { accountNr, originate } = req.params;
  if (accountNr !== 'undefined' && originate !== 'undefined') {
    return res(ctx.status(204));
  }
  return res(ctx.status(400), ctx.json('Missing bank account id.'), ctx.delay(150));
};

/**FILE */

export const mockDeleteFile = async (req, res, ctx) => {
  const { id } = req.params;
  if (id !== 'undefined') {
    return res(ctx.status(200));
  }
  return res(ctx.status(400), ctx.json('Missing file id.'), ctx.delay(150));
};

export const mockUploadFile = async (req, res, ctx) => {
  const { id } = req.params;
  if (id !== 'undefined') {
    return res(ctx.status(200), ctx.json({ ...fileUploadResponse, name: `${id}.extension` }));
  }
  return res(ctx.status(400), ctx.json('Missing file id.'), ctx.delay(150));
};

export const mockReadFile = async (req, res, ctx) => {
  const { id } = req.params;
  if (id !== 'undefined.extension') {
    console.log(id);
    return res(ctx.status(200), ctx.delay(150), ctx.json(finishedFileResponse));
  }
  return res(ctx.status(200), ctx.delay(150), ctx.json(pendingFileResponse));
};

/**AGGREG8 */
export const mockGetAggreg8Tokens = async (req, res, ctx) => {
  const companyId = req.url.searchParams.get('company_id');
  if (companyId) {
    return res(ctx.status(200), ctx.json('customerSyncToken'), ctx.delay(150));
  }
  return res(ctx.status(400), ctx.json('Missing company id.'));
};

export const mockCreateIsc = async (req, res, ctx) => {
  const { company_id } = await req.json();
  if (company_id) {
    return res(ctx.status(200), ctx.json(iscResponse));
  }
  return res(ctx.status(400), ctx.json('Missing company id.'));
};

export const mockAggreg8Response = async (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(responseFromAggreg8));
};

export const mockAggreg8AccountsResponse = async (req, res, ctx) => {
  const company_id = req.url.searchParams.get('company_id');
  if (company_id !== 'must_be_failed_id') {
    return res(ctx.status(200), ctx.json(responseFromAggreg8AccountsListMultipleElement), ctx.delay(100));
  }
  return res(ctx.status(400));
};

export const mockAggreg8StartPull = async (req, res, ctx) => {
  return res(ctx.status(202), ctx.delay(100));
};

export const mockAggreg8UserFlowInit = async (req, res, ctx) => {
  return res(ctx.status(201), ctx.delay(100), ctx.json({ token: 'token' }));
};

export const mockAggreg8BanksResponse = async (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(responseFromAggreg8BanksList), ctx.delay(100));
};

/**CLIENT */
export const mockListAccessTokens = async (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(accessTokenLists), ctx.delay(150));
};
export const mockListIntegrators = async (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(integratorsResponse), ctx.delay(150));
};

export const mockCreateToken = async (req, res, ctx) => {
  const { integrator } = await req.json();
  if (integrator) {
    return res(ctx.status(200), ctx.json(createAccessTokenResponse));
  }
  return res(ctx.status(400), ctx.json(`Missing required parameter(s): ${integrator}.`));
};

export const mockTokenRevoke = async (req, res, ctx) => {
  const { clientId } = await req.json();

  if (clientId) {
    return res(ctx.status(204), ctx.json({}));
  }
  return res(ctx.status(400), ctx.json('Missing file id.'), ctx.delay(150));
};

/**TRANSACTION */
export const mockReadBankAccount = async (req, res, ctx) => {
  const { page } = req.params;

  const { bankAccounts } = await req.json();
  if (bankAccounts.length > 0) {
    if (page > 1) {
      return res(ctx.status(200), ctx.json([]));
    }
    return res(ctx.status(200), ctx.json(transactionResponse));
  }
  return res(ctx.status(400), ctx.json('No bank accounts selected.'), ctx.delay(150));
};

export const mockExportTransaction = async (req, res, ctx) => {
  const { bank_accounts } = await req.json();
  if (bank_accounts) {
    if (bank_accounts.length === 0) {
      return res(ctx.status(200), ctx.json([]));
    }
    if (bank_accounts[0] === 'HU12222222222222222') {
      return res(ctx.status(400));
    }
    return res(ctx.status(200), ctx.json(transactionResponse));
  }

  return res(ctx.status(400), ctx.json('Missing bank_accounts.'));
};

/**AUTHENTICATION */
export const mockLogin = (req, res, ctx) => {
  const token = req.url.searchParams.get('token');
  if (token) {
    const response =
      token === 'entrepreneurToken'
        ? {
            role: USER_TYPE.ENTREPRENEUR,
            user: preRegistered ? entrepreneurResponse : entrepreneurResponseWithoutPreregistered,
          }
        : { role: USER_TYPE.ACCOUNTANT, user: entrepreneurResponse.companies[0].accountants };
    return res(ctx.status(200), ctx.json(response));
  }
  return res(ctx.status(401), ctx.json('Unauthorized.'));
};

/**LOG */
export const mockBooked = (req, res, ctx) => {
  return res(ctx.status(204));
};

/**BANK CONFIGS */
export const mockGetBankConfigs = (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(bankConfigs));
};
